import { render, staticRenderFns } from "./safety-inventory-list.vue?vue&type=template&id=19471628&"
import script from "./safety-inventory-list.vue?vue&type=script&lang=ts&"
export * from "./safety-inventory-list.vue?vue&type=script&lang=ts&"
import style0 from "./safety-inventory-list.vue?vue&type=style&index=0&id=19471628&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports